<template>
  <main id="main">
    <header class="header_page shadow_box slideInDown">
        <p id="title_header_page" class="bold">{{ t('course_qa') }}</p>
        <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
    </header>

    <div class="p-3 pb-5">
        <div class="bg_white p-3 rounded-4 shadow" style="min-height: 80vh">
            <div style="height: 3rem" class="d-flex justify-content-evenly align-items-center mb-4">
                <div 
                    class="d-flex align-items-center justify-content-center flex-wrap gap-1 py-3 w-50 cursor-pointer"
                    :class="{ 'border_bottom_theme': activeTab === 'not_answered' }"
                    @click="activeTab = 'not_answered'"
                >
                    <p class="bold" :class="activeTab === 'not_answered' ? 'text_color_theme' : 'text_color_gray'">{{ t('not_answered') }}</p>
                </div>

                <div style="width: 1px" class="h-100 bg_gray"></div>

                <div 
                    class="d-flex align-items-center justify-content-center flex-wrap gap-1 py-3 w-50 cursor-pointer"
                    :class="{ 'border_bottom_theme': activeTab === 'answered' }"
                    @click="activeTab = 'answered'"
                >
                    <p class="bold" :class="activeTab === 'answered' ? 'text_color_theme' : 'text_color_gray'">{{ t('answered') }}</p>
                </div>
            </div>

            <div v-if="loading" class="text-center mt-5">
                <p>{{ t('loading') }}</p>
            </div>

            <div v-else-if="activeTab === 'not_answered'">
                <div v-if="notAnswered.length === 0" class="text-center mt-5 text_color_gray">
                    {{ t('no_new_question') }}
                </div>
                <div v-else class="d-flex flex-column gap-4">
                    <div v-for="item in notAnswered" :key="item.id" class="shadow-sm p-3 rounded-4 bg_gray_light border border-light">
                        <div class="d-flex align-items-center justify-content-between pb-2 border-bottom mb-3">
                            <p class="font_small bold text_color_theme">
                                {{ item.grade }} - {{ item.lesson_title }} - {{ item.content_title }}
                            </p>
                            <p class="font_tiny text_color_gray text-start">
                                {{ item.created_at_local }}
                            </p>
                        </div>

                        <div class="d-flex flex-column row-gap-2">
                            <div class="d-flex align-items-center gap-2 mb-2">
                                <img src="@/assets/imgs/avatar.svg" style="width: 24px">
                                <span class="font_small bold">{{ item.user_name }}</span>
                                <div class="chart-icon-container cursor-pointer" @click="openChart(item)">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 3V21H21" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M7 17L11 13L15 17L21 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                            </div>
                            
                            <div class="bg_white p-3 rounded-3 mb-2">
                                <span class="d-block font_small bold mb-1 text_color_theme">{{ t('your_question') }} : </span>
                                <span class="d-block font_small text_justify">{{ item.question }}</span>
                            </div>

                            <div class="w-100">
                                <p class="font_small bold mb-2">{{ t('your_answer') }} :</p>
                                <textarea 
                                    v-model="item.answerText"
                                    rows="4" 
                                    class="w-100 rounded-4 p-3 border_gray"
                                    :placeholder="t('write_answer')"
                                ></textarea>
                                <div class="d-flex justify-content-end mt-2">
                                    <button class="button py-2 px-4 font_small" @click="submitAnswer(item)">{{ t('submit_answer') }}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-else-if="activeTab === 'answered'">
                <div v-if="answered.length === 0" class="text-center mt-5 text_color_gray">
                    {{ t('empty_list') }}
                </div>
                <div v-else class="d-flex flex-column gap-4">
                    <div v-for="item in answered" :key="item.id" class="shadow-sm p-3 rounded-4 bg_white border">
                        <div class="d-flex align-items-center justify-content-between pb-2 border-bottom mb-3">
                            <p class="font_small bold text_color_theme">
                                {{ item.grade }} - {{ item.lesson_title }} - {{ item.content_title }}
                            </p>
                            <p class="font_tiny text_color_gray">
                                {{ item.created_at_local }}
                            </p>
                        </div>

                        <div class="d-flex flex-column row-gap-2">
                            <div class="d-flex align-items-center gap-2 mb-2">
                                <img src="@/assets/imgs/avatar.svg" style="width: 24px">
                                <span class="font_small bold">{{ item.user_name }}</span>
                                <div class="chart-icon-container cursor-pointer" @click="openChart(item)">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 3V21H21" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M7 17L11 13L15 17L21 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                            </div>

                            <div class="bg_gray_light p-3 rounded-3 mb-2">
                                <span class="d-block font_small bold mb-1">{{ t('your_question') }} : </span>
                                <span class="d-block font_small text_justify">{{ item.question }}</span>
                            </div>

                            <div class="bg_light_theme_soft p-3 rounded-3">
                                <span class="d-block font_small bold mb-1 text_color_theme">{{ t('your_answer') }} : </span>
                                <span class="d-block font_small text_justify">{{ item.teachers_answer }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div v-if="chartModal.visible" class="modal_overlay" @click.self="chartModal.visible = false">
        <div class="modal_content bg_white rounded-4 p-3 shadow_box w-95" style="max-width: 600px;">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <p class="bold font_medium">{{ t('progress_chart') }}: {{ chartModal.studentName }}</p>
                <img src="@/assets/imgs/close.svg" class="cursor-pointer" style="width: 24px" @click="chartModal.visible = false" alt="">
            </div>
            
            <p class="text_color_theme font_small mb-3 text-center">{{ chartModal.lessonTitle }}</p>

            <div v-if="chartModal.loading" class="text-center py-5">
                <p>{{ t('loading') }}</p>
            </div>
            
            <div v-else-if="!chartModal.data.datasets[0].data.length" class="text-center py-5 text_color_gray">
                {{ t('empty_list') }}
            </div>

            <div v-else class="chart-scroll-container">
                <div class="chart-wrapper" :style="{ width: chartModal.dynamicWidth }">
                    <Line :data="chartModal.data" :options="chartModal.options" />
                </div>
            </div>
        </div>
    </div>

  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'
import { Line } from 'vue-chartjs'
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js'

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend)

export default {
  name: 'TeacherCourseQA',
  components: { Line },
  data() {
    return {
      activeTab: 'not_answered',
      loading: false,
      notAnswered: [],
      answered: [],
      chartModal: {
        visible: false,
        loading: false,
        studentName: '',
        lessonTitle: '',
        dynamicWidth: '100%',
        data: {
            labels: [],
            datasets: [
                {
                    label: 'نمره',
                    backgroundColor: '#4A00E0',
                    borderColor: '#4A00E0',
                    data: [],
                    tension: 0.4,
                    fill: false,
                }
            ]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    labels: {
                        usePointStyle: true,
                        pointStyle: 'circle',
                        font: { size: 14, family: 'inherit' }
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        maxRotation: 90,
                        minRotation: 90,
                        autoSkip: false,
                        font: { size: 10 }
                    }
                },
                y: {
                    beginAtZero: true,
                    max: 100
                }
            },
            elements: {
                point: { radius: 5, hoverRadius: 7, backgroundColor: '#4A00E0' }
            },
            layout: { padding: { bottom: 10 } }
        }
      }
    }
  },
  mounted() {
    this.fetchQuestions()
  },
  methods: {
    async fetchQuestions() {
      this.loading = true
      try {
        const userId = localStorage.getItem('user_id')
        const formData = createFormData({
          teacher_id: userId
        })

        const response = await apiClient.post('/teacher/show_questions_answers', formData)

        if (response.data.status === 'ok' && response.data.data) {
          const data = response.data.data
          this.notAnswered = (data.not_answered || []).map(item => ({...item, answerText: ''}))
          this.answered = data.answered || []
        }
      } catch (error) {
        console.error("TeacherCourseQA Error:", error)
      } finally {
        this.loading = false
      }
    },
    async submitAnswer(item) {
        if (!item.answerText || !item.answerText.trim()) {
            this.notify(this.t('write_answer'), 'error');
            return;
        }

        try {
            const userId = localStorage.getItem('user_id')
            const formData = createFormData({
                teacher_id: userId,
                id: item.id,
                note: item.answerText
            })
            
            const response = await apiClient.post('/teacher/add_answer_to_question', formData) 

            if (response.data.status === 'ok') {
                this.notify(response.data.message || this.t('successful_submit'), 'success');
                this.fetchQuestions();
            } else {
                this.notify(response.data.message || this.t('error_submit'), 'error');
            }
        } catch (error) {
            console.error(error);
            this.notify(this.t('connection_error'), 'error');
        }
    },
    async openChart(item) {
        this.chartModal.visible = true;
        this.chartModal.loading = true;
        this.chartModal.studentName = item.user_name || this.t('student_name');
        this.chartModal.lessonTitle = '';
        this.chartModal.data.labels = [];
        this.chartModal.data.datasets[0].data = [];
        
        try {
            const userId = localStorage.getItem('user_id');
            const formData = createFormData({
                teacher_id: userId,
                lesson_id: item.lesson_id,
                user_id: item.user_id 
            });

            const response = await apiClient.post('/teacher/chart_lessons_details', formData);

            if (response.data.status === 'ok' && response.data.data) {
                const data = response.data.data;
                this.chartModal.lessonTitle = data.lesson_title;
                this.chartModal.studentName = data.student_name || this.chartModal.studentName;
                
                const points = data.points || [];
                this.chartModal.data.labels = points.map(p => p.date);
                this.chartModal.data.datasets[0].data = points.map(p => p.score);

                const widthPerPoint = 50;
                const calculatedWidth = points.length * widthPerPoint;
                this.chartModal.dynamicWidth = calculatedWidth > window.innerWidth ? `${calculatedWidth}px` : '100%';
            }
        } catch (error) {
            console.error(error);
            this.notify(this.t('connection_error'), 'error');
            this.chartModal.visible = false;
        } finally {
            this.chartModal.loading = false;
        }
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}
.bg_gray_light {
    background-color: #f8f9fa;
}
.bg_light_theme_soft {
    background-color: #f0f0ff; 
    border-right: 3px solid #4A00E0;
}
.border_gray {
    border: 1px solid #ddd;
    background-color: white;
}
.font_tiny {
    font-size: 0.75rem;
}
.text_justify {
    text-align: justify;
}
.chart-icon-container {
    width: 28px;
    height: 28px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
    transition: transform 0.2s;
}
.chart-icon-container:active {
    transform: scale(0.9);
}
.modal_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.chart-scroll-container {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch; 
}
.chart-wrapper {
  height: 350px;
  position: relative;
}
</style>